/* 	NOTE:
 */
define(['jquery', 'scrollmagic'], function ($, ScrollMagic) {
    return function (app) {
        var headerOffset = 0;

        app.directive('scrollTracker', ['$rootScope', '$sce', function ($rootScope, $sce) {
            return {
                restrict: "A",
                scope: true,
                bindToController: {
                    navtitle: '=',
                    issticky: '&',
                    scrollController: '&',
                    scrollItems: '@',
                    navItems: '@',
                    navSizeStyle: '&',
                    activetitle: '&'
                },
                controllerAs: 'ctrl',
                controller: ['$scope', function ($scope) {
                    $scope.buffer = 0;
                    $scope.scrollItems = [];
                    $scope.navItems = [];
                    $scope.scrollController = null;
                    $scope.getParentElement = null;
                    $scope.stickyNavigation = false;
                    $scope.navSize = 0;
                    $scope.activetitle = false;
                    $scope.issticky = false;

                    var defaulttitle = 'Default Title';
                    var shouldUpdateNav = true;

                    $scope.$safeApply = function (fn) {
                        var phase = this.$root.$$phase;
                        if (phase == '$apply' || phase == '$digest') {
                            if (fn && (typeof (fn) === 'function')) {
                                fn();
                            }
                        } else {
                            this.$apply(fn);
                        }
                    };

                    $scope.addNavItem = function (title) {
                        var n = ($scope.navItems.length);
                        $scope.navItems.push({
                            'id': n + 1,
                            'title': (title || 'Nav Item ' + n),
                            'active': false
                        });

                        if (n === 0) {
                            $scope.navtitle = $scope.getTrustedText($scope.navItems[0].title);
                        }

                        return $scope.navItems[n];
                    };

                    $scope.addScrollItem = function () {
                        var n = $scope.scrollItems.length;
                        var elementId = 'scroll-section-' + (n);
                        $scope.scrollItems.push({
                            'elementId': elementId,
                            'id': n,
                            'active': false
                        });
                        return $scope.scrollItems[n];
                    }

                    $scope.getParent = function () {
                        return $scope.scrollController;
                    };

                    $scope.setActiveSection = function (state, id) {
                        $scope.$safeApply(function () {

                            angular.forEach($scope.scrollItems, function (item, key) {
                                item.active = (item.id === id);
                            });

                            if (shouldUpdateNav == true) {
                                $scope.setActiveNav(id);
                            }                            
                        });
                    };

                    $scope.setActiveNav = function (id) {
                        angular.forEach($scope.navItems, function (item, key) {
                            item.active = (item.id === id);
                            if (item.id === id) {
                                $scope.navtitle = $scope.getTrustedText(item.title);
                            }
                        });
                    };

                    $scope.removeActive = function (state, id) {
                        $scope.$safeApply(function () {
                            angular.forEach($scope.scrollItems, function (item, key) {
                                if (item.id !== 0) {
                                    item.active = (id !== 0 && item.id === id);
                                }
                            });                            
                        });
                    };                    

                    $scope.onNavigation = function (id) {

                        $scope.activetitle = false;

                        var $item = $('#' + $scope.scrollItems[id].elementId);

                        //If already active, do not do anything
                        if ($item.length < 1) return;
                        //if ($scope.scrollItems[id].active || $item.length < 1) return;
                        var scrollTop = ($('.sticky-nav').length === 1) ? $item.offset().top - (headerOffset) : $item.offset().top - (headerOffset * 1.25);
                        //var scrollTop = $item.offset().top - (headerOffset)

                        //reduce scroll top by section padding height on mobile to offest header
                        if ($(document).width() < 675) {
                            scrollTop -= 45;
                        }

                        shouldUpdateNav = false;

                        $scope.setActiveNav(id);

                        $('html, body').animate({
                            scrollTop: scrollTop
                        }, 1000).promise().done(function () {
                            shouldUpdateNav = true;
                        });
                    };

                    $scope.toggleDropDown = function () {
                        $scope.activetitle = !$scope.activetitle;
                    };

                    $scope.getTrustedText = function (text) {
                        return $sce.trustAsHtml(text);
                    };

                }],
                link: {
                    pre: function ($scope, $element, $attrs) {
                        $scope.scrollController = new ScrollMagic.Controller({}); //END ScrollMagic Controller
                    } //END pre
                }
            }
        }]);

        app.directive("scrollWatch", ['$window', function ($window) {
            return function (scope, element, attrs) {
                angular.element($window).bind("scroll", function () {
                    var $sitebanner = $(element).find('.site-banner');
                    if (this.pageYOffset >= $sitebanner.outerHeight()) {
                        scope.issticky = true;
                    } else {
                        scope.issticky = false;
                    }
                    scope.$apply();
                });
            };
        }]);

        app.directive('scrollTrackerLink', [function () {
            return {
                restrict: "A",
                require: "^scrollTracker",
                scope: true,
                bindToController: {
                    'navitem': '&'
                },
                controllerAs: 'ctrl',
                controller: ['$scope', function ($scope) {
                    $scope.trustedtitle = function () {
                        return $scope.getTrustedText($scope.navitem.title);
                    };
                }],
                link: {
                    pre: function ($scope, $element, $attrs) {
                        $scope.navitem = $scope.addNavItem($attrs.scrollTrackerLink);

                        $scope.onClick = function () {
                            $scope.onNavigation($scope.navitem.id);
                        }

                        $element.attr('id', 'nav-link-' + $scope.navitem.id);
                    }
                }
            }
        }]);

        app.directive('scrollTrackerItem', ['$rootScope', function ($rootScope) {
            return {
                restrict: "A",
                require: "^scrollTracker",
                scope: true,
                bindToController: {
                    scrollItem: '&',
                    navSize: '='
                },
                controllerAs: 'ctrl',
                controller: ['$scope', function ($scope) {
                    $scope.navSize = 'auto';
                    if ($scope.addScrollItem) $scope.scrollItem = $scope.addScrollItem();
                }],
                link: {
                    post: function ($scope, $element, $attrs) {

                        const id = $scope.scrollItem.id;
                        const parentController = $scope.getParent();

                        $element.attr('id', $scope.scrollItem.elementId);

                        var duration = $element[0].offsetHeight;
                        var offset = -($scope.$parent.navSize);
                        var triggerHook = 'onLeave';

                        //we are assuming that 0 is the navigation element
                        switch (id) {
                            case 0:
                                $scope.$parent.navSize = $element[0].offsetHeight;
                                //this ensures that as soon as you start scrolling the nav will stick
                                var offset = -($('.site-banner').height());
                                duration = 0;

                                $(window).resize(function () {
                                    $scope.$parent.navSize = $element[0].offsetHeight;
                                });

                                break;
                            default:
                        }

                        var scene = new ScrollMagic.Scene({
                            triggerElement: $element[0],
                            duration: duration,
                            offset: offset,
                            triggerHook: triggerHook
                        })
                            .addTo(parentController)
                            .on('enter', function (event) {
                                onEnterPanel(event);
                            })
                            .on('leave', function (event) {
                                onLeavePanel(event);
                            });

                        //When user enters the panel - usually on scroll enter
                        const onEnterPanel = function (event) {
                            $scope.setActiveSection(event.state, id);
                        }

                        //When user leaves the panel - usually on scroll leave
                        const onLeavePanel = function (event) {
                            $scope.removeActive(event.state, id);
                        }

                        if (id === 0) {
                            $scope.setNavSize = function () {
                                $scope.navSize = 'auto';
                                $scope.navSize = $($element).height();
                                headerOffset = $scope.navSize;
                                if ($(document).width() < 675) {
                                    //add header to offset on mobile
                                    headerOffset += 21;
                                }
                            };

                            $rootScope.$watch('windowWidth', function () {
                                $scope.setNavSize();
                            });
                        }
                    }
                }
            }
        }]);
    } //end return
});